var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup413(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#b1c1a3",
    stroke: "#748d6f"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-4{stroke:#748d6f}.cls-4,.cls-5{fill:none}.cls-4{stroke-width:2px}.cls-6{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    transform: "translate(-216 -301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    transform: "translate(222.893 307.684) translate(.107 .316)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#b1c1a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_85",
    className: "cls-4",
    transform: "translate(12 9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    className: "cls-6",
    rx: 6.5,
    ry: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    className: "cls-5",
    rx: 5.5,
    ry: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    className: "cls-4",
    transform: "translate(5 20)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13.5,
    className: "cls-6",
    rx: 13,
    ry: 13.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13.5,
    className: "cls-5",
    rx: 12,
    ry: 12.5
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_649",
    d: "M0 0H50V50H0z",
    className: "cls-5",
    transform: "translate(216 301)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup413);
export default __webpack_public_path__ + "static/media/Group 413.f6e10f7de49114226fbcfe1913c500af.svg";
export { ForwardRef as ReactComponent };